import { BasketProduct } from "./basket/basket-product";
import { Configuration2D } from "./configurators-2d/configuration2d";
import { Location } from "./configurators-2d/location";
import { Resume } from "./configurators-2d/resume/resume";

export class BasketConfigurationModel extends Configuration2D {
  basketProducts: BasketProduct[];
  public location: Location;
  discountPercentage?: number;

  set resume(resume: Resume) {
    throw new Error('Method not implemented.');
  }
}
